import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import Input from './Input';
import css from './styles.module.less';

type Props = {
  fieldName: string;
  value: number;
  pageName: 'building' | 'listing';
};

const CountWithSource = memo(({ fieldName, value, pageName }: Props) => {
  const { t } = useTranslation('admin');
  const showSource = value || value === 0;

  const metadataPath = `amenitySet.${fieldName}`;

  return (
    <fieldset className={css.sideBySide}>
      <Input
        key={`${pageName}.${fieldName}`}
        containerClass={showSource ? css.left : css.fullWidth}
        labelText={t(`${pageName}.${fieldName}`)}
        name={metadataPath}
        type="number"
      />
      {showSource ? (
        <Input
          key={`${pageName}.${fieldName}DataSource`}
          containerClass={css.right}
          labelText={t(`${pageName}.dataSource`)}
          name={`${metadataPath}DataSource`}
        />
      ) : null}
    </fieldset>
  );
});

export default CountWithSource;
